import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { fadeOpInOut } from 'src/app/util/animations.util';

@Component({
  selector: 'app-forget-password-verify-code',
  templateUrl: './forget-password-verify-code.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    '../forget-password/forget-password.component.css',
    './forget-password-verify-code.component.css'
  ],
  animations: [
    fadeOpInOut
  ]
})
export class ForgetPasswordVerifyCodeComponent implements OnInit, OnDestroy {
  formCode: FormGroup;
  email: string;
  isCanResend: boolean = true;
  counter: number = 0;
  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private router: Router,
    private snackbar: MatSnackBar,
    private _loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.formCode = this.fb.group({
      code: this.fb.control('', Validators.required)
    });
    this.email = localStorage.getItem('reset-password-email');
    if (!this.email) this.router.navigateByUrl('/auth/forgot-password');
  }

  get code(): FormControl {
    return this.formCode.get('code') as FormControl;
  }

  onVerify(): void {
    this.userService.verifyResetPasswordCode(this.code.value)
    .then(response => {
      const token = response.data.token;
      this.router.navigate(['auth', 'reset-password', token])
    })
    .catch(response => {
      if (!response.errors) return;
      const errorParam = response.errors.find(error => error.param == 'code');
      if (errorParam && errorParam.msg == "Invalid value")
        this.code.setErrors({
          invalid: true
        });
    })
  }

  resendCode(): void {
    this._loadingService._setLoading();
    this.isCanResend = false;
    this.userService.forgotPassword(this.email)
    .then(() => {
      this._loadingService._clearLoading();
      this.countDownOneMinute();
      setTimeout(() => {
        this.isCanResend = true;
      }, 1000 * 60);
      this.snackbar.openFromComponent(SnackbarMessageComponent, {
        data: {
          message: 'MSG.CODE_RESEND'
        },
        panelClass: 'bg-accent',
        duration: 2000
      });
    })
    .catch(() => {
      this.isCanResend = true;
    })
  }
  countDownOneMinute(): void {
    this.counter = 60;
    const handler = setInterval(() => {
      this.counter--;
      if (this.counter == 0)
        clearInterval(handler);
    }, 1000)
  }
  ngOnDestroy(): void {
    this.formCode = null;
    localStorage.removeItem('reset-password-email');
  }
}
